import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DepertmentService } from 'app/services/models/depertment.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-depertmant-dialog',
  templateUrl: './depertmant-dialog.component.html',
  styleUrls: ['./depertmant-dialog.component.scss']
})
export class DepertmantDialogComponent implements OnInit {

  depertmants: any[] = [];
  categoryName: string = null;
  editMode: boolean = false;
  selectedCategoryId: number | null = null;

  constructor(
    private depertmantSerivce: DepertmentService,
    public ngbModal: NgbActiveModal,
    private toastrService: ToastrService
  ) { }

  async ngOnInit() {
    await this.getAllDepertmant();
  }

  async getAllDepertmant() {
    const data = await this.depertmantSerivce.getAllDepertmant();
    this.depertmants = data;
  }

  async saveCategory() {
    if (!this.categoryName.trim()) return;

    if (this.editMode && this.selectedCategoryId !== null) {
      // Güncelleme
      const res = await this.depertmantSerivce.updateDepertmant(this.selectedCategoryId, this.categoryName);
      if (res.status == true) {
        this.toastrService.success(res.message, 'Başarılı');
        this.closeModal(true)
      } else {
        this.toastrService.error(res.message, 'Hata');
      }
    } else {
      // Yeni ekleme
      const res = await this.depertmantSerivce.createDepertmant(this.categoryName);
      if (res.status == true) {
        this.toastrService.success(res.message, 'Başarılı');
        this.closeModal(true)
      } else {
        this.toastrService.error(res.message, 'Hata');
      }
    }

    this.resetForm();
    await this.getAllDepertmant();
  }

  editCategory(cat: any) {
    this.editMode = true;
    this.selectedCategoryId = cat.id;
    this.categoryName = cat.name;
  }

  cancelEdit() {
    this.resetForm();
  }

  resetForm() {
    this.editMode = false;
    this.selectedCategoryId = null;
    this.categoryName = '';
  }

  closeModal(result: boolean = false) {
    this.ngbModal.close(result);
  }

}
